/**
 * Insertable streams for MediaStreamTrack — Chrome and Edge, not yet in the
 * TypeScript DOM library. A processor turns a track into a stream of
 * VideoFrames that the compositor reads as they are captured. Feature-
 * detected before use; Firefox takes the main-thread path.
 *
 * Read off `globalThis` rather than declared as a global, so the SDK's
 * published types add nothing to an app's own globals.
 */

export interface TrackProcessor {
  readonly readable: ReadableStream<VideoFrame>
}

type TrackProcessorClass = new (init: {
  track: MediaStreamTrack
  maxBufferSize?: number
}) => TrackProcessor

/** The browser's MediaStreamTrackProcessor, or undefined where there is none. */
export function trackProcessor(): TrackProcessorClass | undefined {
  return (globalThis as { MediaStreamTrackProcessor?: TrackProcessorClass })
    .MediaStreamTrackProcessor
}
